import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductCategoryService {
    
    
 data$: BehaviorSubject<any[]> = new BehaviorSubject([]);
   
  constructor(private http: HttpClient, private occService:OccEndpointsService) { }

  getProductCategoriesEMEA(){
    return this.http.get(this.occService.buildUrl(`kbhomepage/infoboxesemea`));
  }
  
  setData(newData: any): void {
    this.data$.next(newData);
  }

  getData(): Observable<any[]> {
    return this.data$.asObservable();
  }
  
}
